/*
  Reveal-on-scroll for the custom Ark BioRite sections.

  The theme's built-in scroll animations are switched off in theme settings, and
  turning them on would change every page. This is scoped to elements that opt in
  with [data-ark-reveal].

  The hidden state is applied only once this script runs (via the
  ark-reveal-ready class on <html>), so content stays visible if the script
  fails to load or JavaScript is unavailable.
*/
(function () {
  var READY_CLASS = 'ark-reveal-ready';
  var REVEALED_CLASS = 'is-revealed';
  var SELECTOR = '[data-ark-reveal]';

  function revealAll(items) {
    for (var i = 0; i < items.length; i++) items[i].classList.add(REVEALED_CLASS);
  }

  function init() {
    var items = document.querySelectorAll(SELECTOR + ':not(.' + REVEALED_CLASS + ')');
    if (!items.length) return;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced || !('IntersectionObserver' in window)) {
      revealAll(items);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add(REVEALED_CLASS);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );

    for (var i = 0; i < items.length; i++) observer.observe(items[i]);
  }

  if (window.arkReveal) {
    window.arkReveal();
    return;
  }

  document.documentElement.classList.add(READY_CLASS);
  window.arkReveal = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', init);
})();
